import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import CopyRight from "src/Components/Custom/CopyRight/CopyRight";
import Footer from "src/Components/Custom/Footer/Footer";
import NavBar from "src/Components/Custom/NavBar/NavBar";
import TermsContentAr from "./TermsContentAr";
import TermsContentEn from "./TermsContentEn";
import TermsContentFr from "./TermsContentFr";

function TermsPage() {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  return (
    <Fragment>
      <header>
        <NavBar />
      </header>
      {lang==='ar'? <TermsContentAr/>:
      lang === 'fr' ? <TermsContentFr /> : <TermsContentEn />}
      <Footer />
      <CopyRight />
    </Fragment>
  );
}

export default TermsPage;
